import ChargeAccountData from 'Data/ChargeAccountData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import BOSFilterSelect from './index';

let DM = new DataManager();

const AccountSelect = ({
  orgId,
  category,
  onSelectAccount,
  defaultSelectedId,
  labelText = 'Account...',
}) => {
  const [accountList, setAccountList] = useState([]);

  useEffect(() => {
    DM.add(
      ChargeAccountData.registerListener(
        'ACCOUNTS_FOR_ORG_LOADED',
        onAccountListLoaded,
      ),
      ChargeAccountData,
    );
    DM.add(
      ChargeAccountData.registerListener(
        'RECORDS_LOAD_ERROR',
        onAccountListError,
      ),
      ChargeAccountData,
    );
    DM.add(
      ChargeAccountData.registerListener(
        'ACCOUNTS_FOR_ORG_MODIFIED',
        onAccountListChanged,
      ),
      ChargeAccountData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    fetchAccounts();
  }, [orgId]);

  const fetchAccounts = () => {
    if (orgId) {
      ChargeAccountData.fetchAccountsForOrg(orgId);
    } else {
      setAccountList([]);
    }
  };

  const onAccountListLoaded = (payload) => {
    if (payload?.records) {
      filterAndSetAccounts(payload.records);
    }
  };

  const filterAndSetAccounts = (accounts) => {
    if (!accounts?.length) {
      return;
    }
    let filteredAccounts = accounts.filter(
      (account) => !category || account.category === category,
    );
    setAccountList(filteredAccounts);
  };

  const onAccountListChanged = (payload) => {
    if (payload.orgId == orgId) {
      filterAndSetAccounts(payload.accounts);
    }
  };
  const onAccountListError = () => {};

  return (
    <BOSFilterSelect
      listData={accountList}
      defaultSelectedId={defaultSelectedId}
      onItemSelect={onSelectAccount}
      placeholder={labelText}
      labelFunction={(account) => {
        return `${account.code} ${account.name}`;
      }}
      searchFunction={(account) => {
        return `${account.code} ${account.name}`;
      }}
    />
  );
};

AccountSelect.propTypes = {
  orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  category: PropTypes.string,
  onSelectAccount: PropTypes.func,
  defaultSelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelText: PropTypes.string,
};

export default AccountSelect;
